// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GraphqlTag from "graphql-tag";

var Raw = {};

var query = GraphqlTag.gql(["fragment MenuFragment on AcademyMenuNode   {\n__typename  \nid  \ntitle  \ndescription  \nhasActivities  \nparentId  \n}\n"]);

function parse(value) {
  var value$1 = value.description;
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title,
          description: !(value$1 == null) ? value$1 : undefined,
          hasActivities: value.hasActivities,
          parentId: value.parentId
        };
}

function serialize(value) {
  var value$1 = value.parentId;
  var value$2 = value.hasActivities;
  var value$3 = value.description;
  var description = value$3 !== undefined ? value$3 : null;
  var value$4 = value.title;
  var value$5 = value.id;
  var value$6 = value.__typename;
  return {
          __typename: value$6,
          id: value$5,
          title: value$4,
          description: description,
          hasActivities: value$2,
          parentId: value$1
        };
}

function verifyArgsAndParse(_MenuFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var MenuFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["fragment ActivityFragment on AcademyActivity   {\n__typename  \nid  \ntitle  \nmenuNodeId  \nresult  {\n__typename  \nacademyActivityId  \nkind  \ncontentKind  \nbestScoreNumComplete  \nbestScoreNumCorrect  \nbestResponsesScore  \nstarted  \n}\n\n}\n"]);

function parse$1(value) {
  var value$1 = value.result;
  var value$2 = value$1.contentKind;
  var tmp;
  switch (value$2) {
    case "audio" :
        tmp = "audio";
        break;
    case "custom_word_list" :
        tmp = "custom_word_list";
        break;
    case "example_sentence" :
        tmp = "example_sentence";
        break;
    case "monster_chef" :
        tmp = "monster_chef";
        break;
    case "not_set" :
        tmp = "not_set";
        break;
    case "phonics" :
        tmp = "phonics";
        break;
    case "sound_train" :
        tmp = "sound_train";
        break;
    case "tupperware" :
        tmp = "tupperware";
        break;
    case "video" :
        tmp = "video";
        break;
    case "whack_a_munk" :
        tmp = "whack_a_munk";
        break;
    case "word" :
        tmp = "word";
        break;
    case "word_list" :
        tmp = "word_list";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$2
      };
  }
  var value$3 = value$1.bestResponsesScore;
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title,
          menuNodeId: value.menuNodeId,
          result: {
            __typename: value$1.__typename,
            academyActivityId: value$1.academyActivityId,
            kind: value$1.kind,
            contentKind: tmp,
            bestScoreNumComplete: value$1.bestScoreNumComplete,
            bestScoreNumCorrect: value$1.bestScoreNumCorrect,
            bestResponsesScore: !(value$3 == null) ? value$3 : undefined,
            started: value$1.started
          }
        };
}

function serialize$1(value) {
  var value$1 = value.result;
  var value$2 = value$1.started;
  var value$3 = value$1.bestResponsesScore;
  var bestResponsesScore = value$3 !== undefined ? value$3 : null;
  var value$4 = value$1.bestScoreNumCorrect;
  var value$5 = value$1.bestScoreNumComplete;
  var value$6 = value$1.contentKind;
  var contentKind = typeof value$6 === "object" ? value$6.VAL : (
      value$6 === "not_set" ? "not_set" : (
          value$6 === "example_sentence" ? "example_sentence" : (
              value$6 === "word" ? "word" : (
                  value$6 === "word_list" ? "word_list" : (
                      value$6 === "whack_a_munk" ? "whack_a_munk" : (
                          value$6 === "phonics" ? "phonics" : (
                              value$6 === "sound_train" ? "sound_train" : (
                                  value$6 === "tupperware" ? "tupperware" : (
                                      value$6 === "monster_chef" ? "monster_chef" : (
                                          value$6 === "audio" ? "audio" : (
                                              value$6 === "video" ? "video" : "custom_word_list"
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  var value$7 = value$1.kind;
  var value$8 = value$1.academyActivityId;
  var value$9 = value$1.__typename;
  var result = {
    __typename: value$9,
    academyActivityId: value$8,
    kind: value$7,
    contentKind: contentKind,
    bestScoreNumComplete: value$5,
    bestScoreNumCorrect: value$4,
    bestResponsesScore: bestResponsesScore,
    started: value$2
  };
  var value$10 = value.menuNodeId;
  var value$11 = value.title;
  var value$12 = value.id;
  var value$13 = value.__typename;
  return {
          __typename: value$13,
          id: value$12,
          title: value$11,
          menuNodeId: value$10,
          result: result
        };
}

function verifyArgsAndParse$1(_ActivityFragment, value) {
  return parse$1(value);
}

function verifyName$1(param) {
  
}

var ActivityFragment = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  verifyArgsAndParse: verifyArgsAndParse$1,
  verifyName: verifyName$1
};

export {
  MenuFragment ,
  ActivityFragment ,
}
/* query Not a pure module */
